<template>
    <div class="fm-internal">
        <b-card header="Generate Item QR Code" class="hidden-print">
            

            <b-card-text>
                PRODUCT SKU <b-input size="sm" style="width: 500px;" v-model="data.product_sku"></b-input>
            </b-card-text>
            
            <b-card-text>
                PRODUCT ID <b-input size="sm" style="width: 500px;" v-model="data.product_id" placeholder="Put in -1 for special product (that is not in the system products)"></b-input>
            
            </b-card-text>

            <b-card-text>
                QTY: <b-input v-model="data.qty" size="sm" style="width: 100px;"></b-input>
            </b-card-text>

            <b-card-text>
                <b-button size="sm" variant="success" @click="submitCreateRequests">Submit</b-button>
            </b-card-text>

        </b-card>

        
        <b-card header="Results" style="margin-top: 10px; min-height: 30px; padding: 10px;">
            <b-overlay :show="qrs_being_loaded" rounded="sm">
                <b-card-text>
                    <b-button size="sm" variant="danger" v-if="data.result.length > 0" @click="printDiv" class="hidden-print">Print All</b-button>
                </b-card-text>
                <div id="printSection">
                    <div v-for="qrcode, idx in data.result" style="display: inline-block; padding: 3px;">
                        <div v-if="qrcode.success" >
                            <b-card no-body >
                                <div style="margin: auto;"><b>{{ data.product_sku }}</b></div>
                                <img :src="qrcode.result" style="margin: auto;"/>
                            </b-card>
                        </div>
                    </div>
                </div>
            </b-overlay>
        </b-card>
        
    </div>
</template>

<script>
    import moment from 'moment'
    import global_vars from "@/utilities/global_vars"
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    export default {
        name: "QRGenerator",
        props: ["product"],
        data: function(){
            return {
                data: {
                    product_id: null,
                    product_sku: null,
                    qty: 1,
                    result: [],
                },
                qrs_being_loaded: false
            }
        },
        methods: {
            printDiv: function(e){
                if (e){
                    e.preventDefault();
                }
                this.$htmlToPaper("printSection");
            },
            submitCreateRequests: function(e){
                if (e){
                    e.preventDefault();
                }

                let qty = parseInt(this.data.qty);
                let product_id = this.data.product_id;
                let product_sku = this.data.product_sku;

                if (!product_sku){
                    this.$vex.dialog.alert({
                        message: "Invalid SKU."
                    });
                    return
                }

                if (product_id == null){
                    this.$vex.dialog.alert({
                        message: "Invalid product id."
                    });
                    return
                }

                if (!qty || qty < 1 || qty > 20){
                    this.$vex.dialog.alert({
                        message: "Quantity should be a number betwee 1 and 20. (only 20 QR codes can be printed at a time)."
                    });
                    return
                }

                let that = this;
                let data = {product_id: product_id, product_sku: product_sku, qty: qty};
                let path = "/api/product/generate_qr_codes/"

                let s = function(response){
                    console.log(response, "eeedd")
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.data.result  = response.data.result;
                        that.$bvToast.toast(
                            "Success", 
                            {title: "Error", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                    that.qrs_being_loaded = false;
                }

                let f= function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error occurred.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.qrs_being_loaded = false;
                }
                this.qrs_being_loaded = true;
                Requestor.postSync(path, data, s, f);
            }
        },
        created: function(){           
            if (this.product){
                let product = JSON.parse(JSON.stringify(this.product));
                this.data.product_id = product.product_id;
                this.data.product_sku = product.product_sku;
                this.data.results = []
            }    
        }
    }


</script>


// WEBPACK FOOTER //
// src/components/importables/QRGenerator.vue